import React from 'react';
import { Inbox, Star, Calendar, Menu, User as UserIcon } from 'lucide-react';
import { useApp } from '../contexts/AppContext';
import { useAuth } from '../contexts/AuthContext';

const TABS = [
  { id: 'inbox',    label: 'Inbox',    Icon: Inbox },
  { id: 'today',    label: 'Today',    Icon: Star },
  { id: 'upcoming', label: 'Upcoming', Icon: Calendar },
];

export default function BottomNav() {
  const { state, dispatch } = useApp();
  const { isAuthenticated, openAuthModal } = useAuth();

  const handleSelect = (id) => {
    if (id === 'profile' && !isAuthenticated) {
      openAuthModal();
      return;
    }
    dispatch({ type: 'SET_ACTIVE_VIEW', payload: id });
  };

  const isActive = (id) =>
    state.activeView === id && !state.activeProjectId;

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-30 md:hidden safe-area-bottom bg-white dark:bg-night-surface border-t border-gray-100 dark:border-night-card"
      aria-label="Primary"
    >
      <ul className="grid grid-cols-5 h-16">
        {TABS.map(({ id, label, Icon }) => (
          <li key={id}>
            <button
              type="button"
              onClick={() => handleSelect(id)}
              aria-current={isActive(id) ? 'page' : undefined}
              className={
                'w-full h-full flex flex-col items-center justify-center gap-0.5 text-[10px] font-medium ' +
                (isActive(id)
                  ? 'text-accent dark:text-accent-dark'
                  : 'text-gray-500 dark:text-night-muted')
              }
            >
              <Icon size={20} />
              <span>{label}</span>
            </button>
          </li>
        ))}
        <li>
          <button
            type="button"
            onClick={() => dispatch({ type: 'TOGGLE_SIDEBAR' })}
            className="w-full h-full flex flex-col items-center justify-center gap-0.5 text-[10px] font-medium text-gray-500 dark:text-night-muted"
            aria-label="Open menu"
          >
            <Menu size={20} />
            <span>Menu</span>
          </button>
        </li>
        <li>
          <button
            type="button"
            onClick={() => handleSelect('profile')}
            aria-current={isActive('profile') ? 'page' : undefined}
            className={
              'w-full h-full flex flex-col items-center justify-center gap-0.5 text-[10px] font-medium ' +
              (isActive('profile')
                ? 'text-accent dark:text-accent-dark'
                : 'text-gray-500 dark:text-night-muted')
            }
          >
            <UserIcon size={20} />
            <span>{isAuthenticated ? 'Profile' : 'Sign in'}</span>
          </button>
        </li>
      </ul>
    </nav>
  );
}
